/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgOpenContainer = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M9.626 7h-4.5c-1.5 0-1.5 1.5-1.5 1.5v11c0 1.5 1.5 1.5 1.5 1.5h15s1.5 0 1.5-1.5v-11s0-1.5-1.5-1.5h-4.5v1.5h4.5v11h-15v-11h4.5z" /><path fill="currentColor" d="M13.379 4.5V12h3.247l-4.05 3.9-3.95-3.9 3.25.008V4.5h-6.25V3c2 0 4.25.006 6.25.006 1.503 0 1.503 1.494 1.503 1.494" /></svg>;
export default SvgOpenContainer;